import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../../store/actions/profileActions';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const Bio = ({ bio }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [newBio, setNewBio] = useState('');
    const [editedBio, setEditedBio] = useState('');
    const [open, setOpen] = useState(false);
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
    };
    
    const handleChange = e => {
        if (bio !== e.target.value) {
            setIsEditing(true);
            setNewBio(e.target.value);
        }
        else {
            setIsEditing(false);
            setNewBio(e.target.value);
        }
    }

    const handleReset = () => {
        setNewBio(editedBio);
        setIsEditing(false);
    }

    const handleSave = () => {
        dispatch(actions.updateProfile({...profileState.profile, bio: newBio}))
            .then(() => {
                setOpen(true);
                setIsEditing(false);
            });
    }

    useEffect(() => {
        setNewBio(bio);
        setEditedBio(bio);
    }, [profileState.profile]);

    return (
        <div className="content">
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Profile Successfully Updated!
                </Alert>
            </Snackbar>
            <textarea rows={7} cols={7} value={newBio} onChange={handleChange} className="uni-textarea" name="bio" />
            {isEditing ? 
                <div>
                    <button className="uni-btn" onClick={handleSave}>Save</button>
                    <button className="uni-btn" onClick={handleReset}>Reset</button>
                </div> 
            : null}
        </div>
    )
}

export default Bio;
